"use strict";
class DeveloperUnitCommissionController {
    constructor($scope, $window, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfirmationService, OTPService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.data = SHOWSUITE.data;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.getAllAgencies();
    }

    // API Calls

    getAllAgencies() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest('agencies').then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data.agencies){
                self.all_agencies = response.data.agencies;
            }

            self.getUnitCommissions();
        });
    }

    getUnitCommissions() {
        const self = this;

        self.agencyProjects = null;
        self.agencyProjectUnitCommissions = null;

        let url = 'sec/developer/properties/'+self.data.property.id+'/units/'+self.data.unit.id+'/commission';
        let params = {
            include: 'agencies'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.agencyProjects = response.data.agency_projects;
            self.agencyProjectUnitCommissions = response.data.agency_project_unit_commissions;
            self.agencies = response.data.agencies;

            self.processUnitCommissions();
        });
    }

    saveAgencyProject() {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){

                if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#AgencyProjectForm' + self.agencyProjectParams.id))) {
                self.SSAlertService.warning('Missing Params!', 'Please fill in the required information.');
                return;
                }

                self.agencyProjectErrors = {};

                let url = 'sec/developer/properties/'+self.data.property.id+'/units/'+self.data.unit.id+'/commission';

                loading(true);
                self.SSHttpService.putAPIRequest(url, self.agencyProjectParams).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.agencyProjectErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }

                    if (!self.agencyProjectUnitCommissions) {
                        self.agencyProjectUnitCommissions = [];
                    }

                    let newObject = response.data.agency_project_unit_commission;
                    let existingObject = self.findAgencyProjectUnitCommission(newObject.agency_id, newObject.unit_id);
                    if (existingObject) {
                        angular.merge(existingObject, newObject);
                    } else {
                        self.agencyProjectUnitCommissions.push(newObject);
                    }

                    self.hideAgencyProjectEditForm();
                    self.processUnitCommissions();
                });

        });

    }

    deleteAgencyProject(agencyProjectUnitCommission) {
        const self = this;

        self.SSConfirmationService.getConfirmed('Confirm Delete!',
            'Are you sure you want to reset to the default values?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/'+self.data.property.id+'/units/'+self.data.unit.id+'/commission/delete';
                let params = {
                    agency_id: agencyProjectUnitCommission.agency_id,
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.agencyProjectErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }
                    self.SSAlertService.success('Agency removed successfully.');

                    jQuery.each(self.agencyProjectUnitCommissions, function (i, _agencyProjectUnitCommission) {
                        if (agencyProjectUnitCommission.id == _agencyProjectUnitCommission.id) {
                            self.agencyProjectUnitCommissions.splice(i, 1);
                            return false;
                        }
                    });

                    self.processUnitCommissions();
                });
            }
        );
    }

    // ------------

    processUnitCommissions() {
        const self = this;

        self.processedUnitCommissions = [];

        if (self.agencyProjects == null || self.agencyProjectUnitCommissions == null)
            return;

        jQuery.each(self.agencyProjects, function (i, agencyProject) {
            let agencyProjectUnitCommission = self.findAgencyProjectUnitCommission(agencyProject.agency_id, self.data.unit.id);
            if (!agencyProjectUnitCommission) {
                agencyProjectUnitCommission = {
                    agency_id: agencyProject.agency_id,
                    unit_id: self.data.unit.id
                };
            }

            agencyProjectUnitCommission.default_agency_commission_value = agencyProject.agency_commission_value;
            agencyProjectUnitCommission.default_agency_commission_type = agencyProject.agency_commission_type;
            agencyProjectUnitCommission.default_agency_commission_gst_inclusive = agencyProject.agency_commission_gst_inclusive;

            agencyProjectUnitCommission.default_broker_incentives_value = agencyProject.broker_incentives_value;
            agencyProjectUnitCommission.default_broker_incentives_type = agencyProject.broker_incentives_type;
            agencyProjectUnitCommission.default_broker_incentives_gst_inclusive = agencyProject.broker_incentives_gst_inclusive;

            // Get agency profile to display 'GST Registered/Non-Registered' information
            try{
                let _agency = self.all_agencies.find(x => x.id == agencyProject.agency_id);
                if(_agency && _agency.profile){
                    agencyProjectUnitCommission.agency_profile = _agency.profile;  
                }
                else{
                    agencyProjectUnitCommission.agency_profile = {};  
                }
            }
            catch(ex){
                console.log(ex);
            }

            self.processedUnitCommissions.push(agencyProjectUnitCommission);
        });
    }

    findAgency(agencyId) {
        const self = this;

        let agency = null;

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, _agency) {
                if (agencyId == _agency.id) {
                    agency = _agency;
                    return false;
                }
            });
        }

        return agency;
    }

    getAgencyName(agencyId) {
        const self = this;

        let agency = self.findAgency(agencyId);

        return agency ? agency.name : '';
    }

    findAgencyProject(agencyId) {
        const self = this;

        let agencyProject = null;

        if (self.agencyProjects) {
            jQuery.each(self.agencyProjects, function (i, _agencyProject) {
                if (agencyId == _agencyProject.agency_id) {
                    agencyProject = _agencyProject;
                    return false;
                }
            });
        }

        return agencyProject;
    }

    findAgencyProjectUnitCommission(agencyId, unitId) {
        const self = this;

        let agencyProjectUnitCommission = null;

        if (self.agencyProjectUnitCommissions) {
            jQuery.each(self.agencyProjectUnitCommissions, function (i, _agencyProjectUnitCommission) {
                if (_agencyProjectUnitCommission.agency_id == agencyId
                    && _agencyProjectUnitCommission.unit_id == unitId
                ) {
                    agencyProjectUnitCommission = _agencyProjectUnitCommission;
                    return false;
                }
            });
        }

        return agencyProjectUnitCommission;
    }

    formatValue(type, value, gst_inclusive) {
        const self = this;

        if (value == null)
            return '--';

        let _value = '';

        if (!type || type == 10) {
            _value = self.SSUtilService.formatPercentage(value);
        } else if (type == 20) {
            _value = self.SSUtilService.formatCurrency(value);
        }

        _value += gst_inclusive == 1 ? ' (With GST)' : ' (Without GST)';

        return _value;
    }
    // ------------

    showAgencyProjectEditForm(agencyProjectUnitCommission) {
        const self = this;

        self.agencyProjectParams = {};
        self.agencyProjectErrors = {};

        if (!agencyProjectUnitCommission) {
            return;
        }

        if (self.processedUnitCommissions) {
            jQuery.each(self.processedUnitCommissions, function (i, _obj) {
                if (agencyProjectUnitCommission.agency_id == _obj.agency_id
                    && agencyProjectUnitCommission.unit_id == _obj.unit_id
                ) {
                    _obj.editable = 1;
                    self.agencyProjectParams = angular.copy(_obj);
                } else {
                    _obj.editable = null;
                }
            });
        }
    }

    hideAgencyProjectEditForm() {
        const self = this;

        self.agencyProjectParams = {};
        self.agencyProjectErrors = {};

        if (!self.processedUnitCommissions) {
            return;
        }

        jQuery.each(self.processedUnitCommissions, function (i, _obj) {
            _obj.editable = null;
        });
    }

}

DeveloperUnitCommissionController.$inject = ['$scope', '$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfirmationService', 'OTPService'];
app.controller('DeveloperUnitCommissionController', DeveloperUnitCommissionController);
